import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { getShare } from "@/lib/api";
import { COLLECTIONS, colorLabel } from "@/data/collections";

export default function Share() {
  const { reference } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    getShare(reference).then(setData).catch(() => setError(true));
  }, [reference]);

  const collection = COLLECTIONS.find((c) => c.id === data?.collection_id);
  const photo = data?.finished_photo_base64 || collection?.image;
  const colors = Object.entries(data?.custom_colors || {});

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <section className="pp-container py-16 sm:py-20">
        {error ? (
          <p className="text-center" data-testid="share-not-found">We couldn't find that porch.</p>
        ) : !data ? (
          <div className="text-center"><Loader2 className="h-6 w-6 animate-spin inline" /></div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-testid="share-card">
            <div className="lg:col-span-7 aspect-[4/5] sm:aspect-[5/4] overflow-hidden">
              <img src={photo} alt="Styled porch" className="h-full w-full object-cover" />
            </div>
            <div className="lg:col-span-5">
              <div className="pp-caption mb-3">{data.first_name ? `${data.first_name}'s porch` : "A styled porch"}</div>
              <h1 className="font-serif-display text-5xl sm:text-6xl font-light leading-tight" style={{ color: "var(--pp-burgundy)" }}>
                {data.collection_name.endsWith("Collection") ? `The ${data.collection_name}` : `The ${data.collection_name} Collection`}
              </h1>
              <p className="mt-5 leading-relaxed" style={{ color: "var(--pp-text-muted)" }}>
                {collection?.description}
              </p>
              <dl className="mt-6 space-y-2 text-sm" style={{ color: "var(--pp-text-muted)" }}>
                <div><span style={{ color: "var(--pp-burgundy)" }}>Size:</span> {data.size_label}</div>
                {colors.length > 0 && <div><span style={{ color: "var(--pp-burgundy)" }}>Colors:</span> {colors.map(([k, v]) => `${colorLabel(k)} × ${v}`).join(", ")}</div>}
              </dl>
              <div className="mt-10 h-px w-full" style={{ backgroundColor: "var(--pp-border)" }} />
              <p className="mt-6 text-sm" style={{ color: "var(--pp-text-muted)" }}>Want one for your own front step?</p>
              <Link to="/" data-testid="share-cta" className="pp-btn mt-4">Book your porch <ArrowRight className="h-4 w-4" /></Link>
            </div>
          </div>
        )}
      </section>
      <div className="flex-1" />
      <Footer />
    </div>
  );
}
